interface SurgeryIconProps {
  className?: string;
}

export function SurgeryIcon({ className }: SurgeryIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32 8.48614L15.205 25.6999L14.8522 25.3665L11.2154 29.0944L11.1465 29.1647L11.0478 29.168L0 29.5L9.22269 20.0467L8.87087 19.7143L25.6664 2.5L32 8.48614ZM3.53525 27.9521L10.5084 27.7425L13.7977 24.3701L10.2758 21.0422L3.53525 27.9521ZM31.6553 8.49318L15.1974 25.3604L15.1979 25.3609L31.6553 8.49318ZM10.9381 19.6707L15.1641 23.6649L17.1915 21.5862L12.9654 17.5924L10.9381 19.6707ZM13.9791 16.5538L18.2047 20.548L29.9337 8.52694L25.7077 4.53321L13.9791 16.5538Z"
        fill="currentColor"
      />
    </svg>
  );
}
